import apiClient from './apiClient';

export interface PermissionDisplayMetadata {
  name: string;
  display_name: string;
  display_description: string;
  category: 'upload' | 'image_processing' | 'admin';
  icon_name: string;
  display_order: number;
  show_in_subscription_table: boolean;
  show_in_user_dashboard: boolean;
  help_text: string | null;
}

export const permissionService = {
  getDisplayMetadata: async (showInSubscriptionTable?: boolean): Promise<PermissionDisplayMetadata[]> => {
    const params = showInSubscriptionTable !== undefined
      ? { show_in_subscription_table: showInSubscriptionTable }
      : {};
    const response = await apiClient.get('/permissions/display-metadata', { params });
    return response.data.data;
  }
};

